<svg
  xmlns="http://www.w3.org/2000/svg"
  xml:space="preserve"
  width="300px"
  height="60px"
  viewBox="0 0 4800 522"
  class="SignInButton"
>
  <style type="text/css">
    .fnt0 {
      font-size: 230px;
      font-weight: 700;
      text-decoration: none;
    }
  </style>

  <rect
    x="400"
    y="0"
    width="4000"
    height="688"
    rx="125"
    ry="125"
    style="fill: rgb(255, 255, 255); stroke-width: 15; stroke: #8392ab"
  />
  <rect x="700" y="209" width="122" height="122" fill="#F35325" />
  <rect x="834" y="209" width="122" height="122" fill="#81BC06" />
  <rect x="700" y="343" width="122" height="122" fill="#05A6F0" />
  <rect x="834" y="343" width="122" height="122" fill="#FFBA08" />
  <text x="1120" y="427" fill="#8392ab" class="fnt0">{{ label }}</text>
</svg>
